import { render } from "./scrollAnchor.vue?vue&type=template&id=600b86c2&scoped=true"
import script from "./scrollAnchor.vue?vue&type=script&lang=js"
export * from "./scrollAnchor.vue?vue&type=script&lang=js"

import "./scrollAnchor.vue?vue&type=style&index=0&id=600b86c2&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600b86c2"]])

export default __exports__